export const CMC_DOCTORS = [
  {
    i: "D0001101",
    hid: "cmcseoul",
    n: "이재호",
    de: "가정의학과",
    s: ["건강검진", "만성질환관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000969",
    hid: "cmcseoul",
    n: "김철민",
    de: "가정의학과",
    s: ["암생존자 건강관리", "건강증진 및 삶의 질 향상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000829",
    hid: "cmcseoul",
    n: "최창진",
    de: "가정의학과",
    s: ["암 경험자", "노인의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002894",
    hid: "cmcseoul",
    n: "신현영",
    de: "가정의학과",
    s: ["암환자 건강", "비만"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003116",
    hid: "cmcseoul",
    n: "허연",
    de: "가정의학과",
    s: ["암 경험자", "노인의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000937",
    hid: "cmcseoul",
    n: "유영경",
    de: "간담췌외과",
    s: ["간이식", "간담도췌장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001221",
    hid: "cmcseoul",
    n: "홍태호",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001279",
    hid: "cmcseoul",
    n: "김세준",
    de: "간담췌외과",
    s: ["담췌질환", "간질환제외"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000127",
    hid: "cmcseoul",
    n: "최호중",
    de: "간담췌외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002234",
    hid: "cmcseoul",
    n: "한의수",
    de: "간담췌외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001591",
    hid: "cmcseoul",
    n: "박성은",
    de: "간담췌외과",
    s: ["담석증", "췌담도질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002361",
    hid: "cmcseoul",
    n: "전진하",
    de: "간담췌외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003044",
    hid: "cmcseoul",
    n: "김지영",
    de: "간담췌외과",
    s: ["간이식", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000824",
    hid: "cmcseoul",
    n: "김상일",
    de: "감염내과",
    s: ["장기이식 감염", "[불명열]"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000912",
    hid: "cmcseoul",
    n: "이동건",
    de: "감염내과",
    s: ["혈액질환 환자의 감염예방", "진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000319",
    hid: "cmcseoul",
    n: "조성연",
    de: "감염내과",
    s: ["혈액질환 환자의 감염예방", "진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001557",
    hid: "cmcseoul",
    n: "전윤희",
    de: "감염내과",
    s: ["발열질환", "림프절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001388",
    hid: "cmcseoul",
    n: "이래석",
    de: "감염내과",
    s: ["혈액질환 환자의 감염예방", "진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002354",
    hid: "cmcseoul",
    n: "노덕희",
    de: "감염내과",
    s: ["혈액질환 환자의 감염예방", "진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002242",
    hid: "cmcseoul",
    n: "홍한터",
    de: "감염내과",
    s: ["혈액질환 환자의 감염예방", "진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001199",
    hid: "cmcseoul",
    n: "배자성",
    de: "갑상선내분비외과",
    s: ["갑상선암", "갑상선결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001593",
    hid: "cmcseoul",
    n: "김광순",
    de: "갑상선내분비외과",
    s: ["갑상선암", "갑상선결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002362",
    hid: "cmcseoul",
    n: "박준선",
    de: "갑상선내분비외과",
    s: ["갑상선암", "갑상선결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001369",
    hid: "cmcseoul",
    n: "신현화",
    de: "갑상선내분비외과",
    s: ["입원전문의"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002560",
    hid: "cmcseoul",
    n: "안솔지",
    de: "갑상선내분비외과",
    s: ["갑상선암", "갑상선결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003138",
    hid: "cmcseoul",
    n: "신승환",
    de: "갑상선내분비외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000806",
    hid: "cmcseoul",
    n: "김영균",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000197",
    hid: "cmcseoul",
    n: "함은재",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000783",
    hid: "cmcseoul",
    n: "김향선",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000330",
    hid: "cmcseoul",
    n: "강경진",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000437",
    hid: "cmcseoul",
    n: "안재원",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000243",
    hid: "cmcseoul",
    n: "이동현",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000003",
    hid: "cmcseoul",
    n: "정재은",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000483",
    hid: "cmcseoul",
    n: "오영아",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000152",
    hid: "cmcseoul",
    n: "조현선",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000137",
    hid: "cmcseoul",
    n: "유승희",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000179",
    hid: "cmcseoul",
    n: "이장은",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000165",
    hid: "cmcseoul",
    n: "정문경",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000172",
    hid: "cmcseoul",
    n: "신주영",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000175",
    hid: "cmcseoul",
    n: "정희선",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000542",
    hid: "cmcseoul",
    n: "정윤주",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000488",
    hid: "cmcseoul",
    n: "박세나",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001278",
    hid: "cmcseoul",
    n: "이현정",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000269",
    hid: "cmcseoul",
    n: "장희재",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002464",
    hid: "cmcseoul",
    n: "김봄이",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001366",
    hid: "cmcseoul",
    n: "임송원",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002471",
    hid: "cmcseoul",
    n: "정현조",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000589",
    hid: "cmcseoul",
    n: "태혜진",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000731",
    hid: "cmcseoul",
    n: "서병규",
    de: "건강증진의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001134",
    hid: "cmcseoul",
    n: "임동준",
    de: "내분비내과",
    s: ["갑상선암", "갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001136",
    hid: "cmcseoul",
    n: "조재형",
    de: "내분비내과",
    s: ["당뇨병", "고지혈증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000066",
    hid: "cmcseoul",
    n: "이승환",
    de: "내분비내과",
    s: ["당뇨병", "고지혈증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001246",
    hid: "cmcseoul",
    n: "김헌성",
    de: "내분비내과",
    s: ["당뇨병", "고지혈증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000651",
    hid: "cmcseoul",
    n: "이은영",
    de: "내분비내과",
    s: ["당뇨병", "뇌하수체"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000527",
    hid: "cmcseoul",
    n: "하정훈",
    de: "내분비내과",
    s: ["골대사질환", "뇌하수체질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002066",
    hid: "cmcseoul",
    n: "이준엽",
    de: "내분비내과",
    s: ["당뇨병", "비만 및 기타 내분비 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000460",
    hid: "cmcseoul",
    n: "양여리",
    de: "내분비내과",
    s: ["당뇨병", "고지혈증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002068",
    hid: "cmcseoul",
    n: "유진",
    de: "내분비내과",
    s: ["당뇨병", "비만 및 기타 내분비질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002848",
    hid: "cmcseoul",
    n: "이재경",
    de: "내분비내과",
    s: ["갑상선", "당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002847",
    hid: "cmcseoul",
    n: "김미숙",
    de: "내분비내과",
    s: ["당뇨병", "갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003135",
    hid: "cmcseoul",
    n: "한병훈",
    de: "내분비내과",
    s: ["당뇨병", "갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000853",
    hid: "cmcseoul",
    n: "최윤희",
    de: "내분비내과",
    s: ["당뇨", "임신성 당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002663",
    hid: "cmcseoul",
    n: "김지현",
    de: "내분비내과",
    s: ["당뇨", "갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001032",
    hid: "cmcseoul",
    n: "이도상",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000858",
    hid: "cmcseoul",
    n: "조현민",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001083",
    hid: "cmcseoul",
    n: "이인규",
    de: "대장항문외과",
    s: ["로봇수술", "[대장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001086",
    hid: "cmcseoul",
    n: "이윤석",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001485",
    hid: "cmcseoul",
    n: "배정훈",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002359",
    hid: "cmcseoul",
    n: "김인경",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002152",
    hid: "cmcseoul",
    n: "최보윤",
    de: "대장항문외과",
    s: ["입원전문의"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001048",
    hid: "cmcseoul",
    n: "박성환",
    de: "류마티스내과",
    s: ["루푸스", "쇼그렌증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001176",
    hid: "cmcseoul",
    n: "김완욱",
    de: "류마티스내과",
    s: ["류마티스관절염", "강직성척추염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001150",
    hid: "cmcseoul",
    n: "주지현",
    de: "류마티스내과",
    s: ["줄기세포", "류마티스관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001189",
    hid: "cmcseoul",
    n: "곽승기",
    de: "류마티스내과",
    s: ["루푸스", "쇼그렌증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000536",
    hid: "cmcseoul",
    n: "이주하",
    de: "류마티스내과",
    s: ["강직성척추염", "건선관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000089",
    hid: "cmcseoul",
    n: "이지연",
    de: "류마티스내과",
    s: ["(입원환자 협진불가)근골격계 및 류마티스질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001722",
    hid: "cmcseoul",
    n: "박영재",
    de: "류마티스내과",
    s: ["쇼그렌증후군", "루푸스"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002064",
    hid: "cmcseoul",
    n: "이봉우",
    de: "류마티스내과",
    s: ["류마티스질환(일반)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002553",
    hid: "cmcseoul",
    n: "양지원",
    de: "류마티스내과",
    s: ["류마티스질환(일반)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002821",
    hid: "cmcseoul",
    n: "박희원",
    de: "류마티스내과",
    s: ["류마티스질환(일반)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000840",
    hid: "cmcseoul",
    n: "이해진",
    de: "마취통증의학과",
    s: ["산부인과 마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000986",
    hid: "cmcseoul",
    n: "이윤기",
    de: "마취통증의학과",
    s: ["외래마취", "뇌신경마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001111",
    hid: "cmcseoul",
    n: "한인수",
    de: "마취통증의학과",
    s: ["기도관리", "일반마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001224",
    hid: "cmcseoul",
    n: "박철수",
    de: "마취통증의학과",
    s: ["간이식마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000037",
    hid: "cmcseoul",
    n: "박휴정",
    de: "마취통증의학과",
    s: ["척추 관련 통증", "대상포진 및 각종 신경병증성 통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000087",
    hid: "cmcseoul",
    n: "홍상현",
    de: "마취통증의학과",
    s: ["이식수술마취", "부위마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000116",
    hid: "cmcseoul",
    n: "문영은",
    de: "마취통증의학과",
    s: ["수술 후 급성통증", "일반 마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000060",
    hid: "cmcseoul",
    n: "정현식",
    de: "마취통증의학과",
    s: ["일반마취", "장기이식마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000170",
    hid: "cmcseoul",
    n: "황원정",
    de: "마취통증의학과",
    s: ["심폐마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001559",
    hid: "cmcseoul",
    n: "심성은",
    de: "마취통증의학과",
    s: ["척추 관련 통증", "대상포진 및 각종 신경병증성 통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000184",
    hid: "cmcseoul",
    n: "주진",
    de: "마취통증의학과",
    s: ["뇌신경마취", "외래마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000033",
    hid: "cmcseoul",
    n: "고현정",
    de: "마취통증의학과",
    s: ["마취: 진정(고도진정)마취", "정형외과 마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001697",
    hid: "cmcseoul",
    n: "김지연",
    de: "마취통증의학과",
    s: ["통원수술마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000548",
    hid: "cmcseoul",
    n: "허재원",
    de: "마취통증의학과",
    s: ["심폐마취", "혈관중재마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001493",
    hid: "cmcseoul",
    n: "최훈",
    de: "마취통증의학과",
    s: ["심폐마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001374",
    hid: "cmcseoul",
    n: "심정우",
    de: "마취통증의학과",
    s: ["소아마취", "소아심장마취"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001723",
    hid: "cmcseoul",
    n: "박재식",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001987",
    hid: "cmcseoul",
    n: "이구상",
    de: "마취통증의학과",
    s: ["신경병증성 통증", "두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002850",
    hid: "cmcseoul",
    n: "김종완",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002562",
    hid: "cmcseoul",
    n: "김민주",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003126",
    hid: "cmcseoul",
    n: "고재민",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003125",
    hid: "cmcseoul",
    n: "김동욱",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003136",
    hid: "cmcseoul",
    n: "김주원",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003129",
    hid: "cmcseoul",
    n: "주민아",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002470",
    hid: "cmcseoul",
    n: "강다인",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002096",
    hid: "cmcseoul",
    n: "이누리",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002623",
    hid: "cmcseoul",
    n: "노수진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003031",
    hid: "cmcseoul",
    n: "이기영",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003034",
    hid: "cmcseoul",
    n: "권지숙",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002974",
    hid: "cmcseoul",
    n: "조유빈",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001118",
    hid: "cmcseoul",
    n: "김연실",
    de: "방사선종양학과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000826",
    hid: "cmcseoul",
    n: "최병옥",
    de: "방사선종양학과",
    s: ["유방암(유방전절제술", "재발 제외)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001186",
    hid: "cmcseoul",
    n: "강영남",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000080",
    hid: "cmcseoul",
    n: "이동수",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001556",
    hid: "cmcseoul",
    n: "송진호",
    de: "방사선종양학과",
    s: ["뇌종양", "혈액종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002018",
    hid: "cmcseoul",
    n: "손석현",
    de: "방사선종양학과",
    s: ["전립선암", "신장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001601",
    hid: "cmcseoul",
    n: "최규혜",
    de: "방사선종양학과",
    s: ["림프종", "대장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000504",
    hid: "cmcseoul",
    n: "성수윤",
    de: "방사선종양학과",
    s: ["폐암", "두경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002015",
    hid: "cmcseoul",
    n: "홍지현",
    de: "방사선종양학과",
    s: ["혈액암(급성림프모구성백혈병", "다발골수종 제외)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002468",
    hid: "cmcseoul",
    n: "이영규",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002702",
    hid: "cmcseoul",
    n: "천원중",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000814",
    hid: "cmcseoul",
    n: "최영진",
    de: "병리과",
    s: ["신장병리", "이식병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000981",
    hid: "cmcseoul",
    n: "이연수",
    de: "병리과",
    s: ["신경병리", "두경부병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000915",
    hid: "cmcseoul",
    n: "박경신",
    de: "병리과",
    s: ["혈액 병리", "피부 병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000947",
    hid: "cmcseoul",
    n: "이아원",
    de: "병리과",
    s: ["유방병리", "여성생식기병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001149",
    hid: "cmcseoul",
    n: "정찬권",
    de: "병리과",
    s: ["내분비 병리", "골연부종양병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000091",
    hid: "cmcseoul",
    n: "이성학",
    de: "병리과",
    s: ["위장관병리", "간담췌병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000622",
    hid: "cmcseoul",
    n: "강준",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002396",
    hid: "cmcseoul",
    n: "김영훈",
    de: "병리과",
    s: ["소화기병리", "간담췌병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001602",
    hid: "cmcseoul",
    n: "성연은",
    de: "병리과",
    s: ["심폐병리", "신장병리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002098",
    hid: "cmcseoul",
    n: "김수연",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002097",
    hid: "cmcseoul",
    n: "이미선",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002395",
    hid: "cmcseoul",
    n: "김미정",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002629",
    hid: "cmcseoul",
    n: "이현",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002975",
    hid: "cmcseoul",
    n: "전지현",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003121",
    hid: "cmcseoul",
    n: "김수화",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003122",
    hid: "cmcseoul",
    n: "손희승",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000939",
    hid: "cmcseoul",
    n: "김세웅",
    de: "비뇨의학과",
    s: ["전립선질환", "성기능"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001122",
    hid: "cmcseoul",
    n: "이지열",
    de: "비뇨의학과",
    s: ["비뇨기종양", "로봇 및 복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001079",
    hid: "cmcseoul",
    n: "홍성후",
    de: "비뇨의학과",
    s: ["비뇨기종양", "로봇 및 복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001219",
    hid: "cmcseoul",
    n: "하유신",
    de: "비뇨의학과",
    s: ["비뇨기종양", "로봇 및 복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000325",
    hid: "cmcseoul",
    n: "조혁진",
    de: "비뇨의학과",
    s: ["전립선암", "신장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000140",
    hid: "cmcseoul",
    n: "배웅진",
    de: "비뇨의학과",
    s: ["전립선비대증.신경인성 방광.배뇨장애", "소아"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000635",
    hid: "cmcseoul",
    n: "박용현",
    de: "비뇨의학과",
    s: ["비뇨기종양", "로봇및복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000560",
    hid: "cmcseoul",
    n: "문형우",
    de: "비뇨의학과",
    s: ["비뇨기 종양", "로봇 및 복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002304",
    hid: "cmcseoul",
    n: "방석환",
    de: "비뇨의학과",
    s: ["비뇨기종양", "로봇및복강경수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002390",
    hid: "cmcseoul",
    n: "신동호",
    de: "비뇨의학과",
    s: ["비뇨기종양(전립선암", "신장암)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002954",
    hid: "cmcseoul",
    n: "양종협",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001161",
    hid: "cmcseoul",
    n: "김미란",
    de: "산부인과",
    s: ["자궁근종", "자궁내막증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001115",
    hid: "cmcseoul",
    n: "허수영",
    de: "산부인과",
    s: ["자궁경부이형증", "자궁경부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001026",
    hid: "cmcseoul",
    n: "박인양",
    de: "산부인과",
    s: ["고위험임신", "선천성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001023",
    hid: "cmcseoul",
    n: "이근호",
    de: "산부인과",
    s: ["(유전성)난소암", "자궁내막암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001188",
    hid: "cmcseoul",
    n: "고현선",
    de: "산부인과",
    s: ["고위험임신", "선천성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001227",
    hid: "cmcseoul",
    n: "이성종",
    de: "산부인과",
    s: ["자궁경부암", "난소암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000088",
    hid: "cmcseoul",
    n: "송재연",
    de: "산부인과",
    s: ["자궁내막증", "자궁근종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000320",
    hid: "cmcseoul",
    n: "최윤진",
    de: "산부인과",
    s: ["(유전성)난소암", "자궁내막암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000226",
    hid: "cmcseoul",
    n: "정윤지",
    de: "산부인과",
    s: ["갱년기", "골다공증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001060",
    hid: "cmcseoul",
    n: "이영",
    de: "산부인과",
    s: ["나프로임신법"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001880",
    hid: "cmcseoul",
    n: "홍수빈",
    de: "산부인과",
    s: ["정상임신", "고위험임신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002380",
    hid: "cmcseoul",
    n: "최보람",
    de: "산부인과",
    s: ["(유전성)난소암", "자궁내막암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002101",
    hid: "cmcseoul",
    n: "박정윤",
    de: "산부인과",
    s: ["일반 부인과", "골다공증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002569",
    hid: "cmcseoul",
    n: "박정현",
    de: "산부인과",
    s: ["자궁근종", "자궁내막증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002882",
    hid: "cmcseoul",
    n: "엄지수",
    de: "산부인과",
    s: ["정상임신", "고위험임신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003076",
    hid: "cmcseoul",
    n: "김나리네",
    de: "산부인과",
    s: ["정상임신", "고위험임신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001194",
    hid: "cmcseoul",
    n: "전영준",
    de: "성형외과",
    s: ["안면외상", "피부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001204",
    hid: "cmcseoul",
    n: "오득영",
    de: "성형외과",
    s: ["유방재건", "눈성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000128",
    hid: "cmcseoul",
    n: "문석호",
    de: "성형외과",
    s: ["상하지재건", "피부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001330",
    hid: "cmcseoul",
    n: "최장연",
    de: "성형외과",
    s: ["유방재건", "수부재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001714",
    hid: "cmcseoul",
    n: "최종윤",
    de: "성형외과",
    s: ["안면외상", "수부외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002583",
    hid: "cmcseoul",
    n: "이채림",
    de: "성형외과",
    s: ["안면외상", "양성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001003",
    hid: "cmcseoul",
    n: "정재희",
    de: "소아외과",
    s: ["선천성항문직장기형", "선천성거대결장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001033",
    hid: "cmcseoul",
    n: "조빈",
    de: "소아청소년과",
    s: ["소아백혈병", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000985",
    hid: "cmcseoul",
    n: "정대철",
    de: "소아청소년과",
    s: ["불명열", "관절통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001164",
    hid: "cmcseoul",
    n: "정낙균",
    de: "소아청소년과",
    s: ["[소아백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000381",
    hid: "cmcseoul",
    n: "이재영",
    de: "소아청소년과",
    s: ["선천성 심질환 및 중재시술", "심근증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000982",
    hid: "cmcseoul",
    n: "최병준",
    de: "소아청소년과",
    s: ["육아상담", "소아간질"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000113",
    hid: "cmcseoul",
    n: "이재욱",
    de: "소아청소년과",
    s: ["[소아백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000158",
    hid: "cmcseoul",
    n: "윤영아",
    de: "소아청소년과",
    s: ["신생아 질환", "미숙아 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000058",
    hid: "cmcseoul",
    n: "엄태훈",
    de: "소아청소년과",
    s: ["소아간질및경련성질환", "두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001566",
    hid: "cmcseoul",
    n: "강현미",
    de: "소아청소년과",
    s: ["발열", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001749",
    hid: "cmcseoul",
    n: "김세연",
    de: "소아청소년과",
    s: ["신생아질환", "미숙아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000459",
    hid: "cmcseoul",
    n: "안문배",
    de: "소아청소년과",
    s: ["성장 및 성조숙증", "갑상선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001876",
    hid: "cmcseoul",
    n: "류인혁",
    de: "소아청소년과",
    s: ["만성복통", "저체중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000661",
    hid: "cmcseoul",
    n: "이혜진",
    de: "소아청소년과",
    s: ["소아 호흡기", "알레르기 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002047",
    hid: "cmcseoul",
    n: "유재원",
    de: "소아청소년과",
    s: ["소아백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001567",
    hid: "cmcseoul",
    n: "이연희",
    de: "소아청소년과",
    s: ["소아신장질환", "학교소변검사이상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002046",
    hid: "cmcseoul",
    n: "오문연",
    de: "소아청소년과",
    s: ["신생아질환", "미숙아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002467",
    hid: "cmcseoul",
    n: "신정민",
    de: "소아청소년과",
    s: ["신생아질환", "미숙아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003115",
    hid: "cmcseoul",
    n: "최정호",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003108",
    hid: "cmcseoul",
    n: "김현호",
    de: "소아청소년과",
    s: ["신생아 질환", "미숙아 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001615",
    hid: "cmcseoul",
    n: "신주애",
    de: "소아청소년과",
    s: ["선천성심질환", "심잡음"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002108",
    hid: "cmcseoul",
    n: "김예지",
    de: "소아청소년과",
    s: ["발열", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002109",
    hid: "cmcseoul",
    n: "김민수",
    de: "소아청소년과",
    s: ["신생아", "미숙아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002384",
    hid: "cmcseoul",
    n: "조수정",
    de: "소아청소년과",
    s: ["소아백혈병", "림프종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002529",
    hid: "cmcseoul",
    n: "이인경",
    de: "소아청소년과",
    s: ["소아중환자의학", "소아 가정용 인공호흡기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002383",
    hid: "cmcseoul",
    n: "심수연",
    de: "소아청소년과",
    s: ["성장장애 및 성조숙증", "성선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002928",
    hid: "cmcseoul",
    n: "최호정",
    de: "소아청소년과",
    s: ["소아내시경", "만성복통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002969",
    hid: "cmcseoul",
    n: "김언아",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002967",
    hid: "cmcseoul",
    n: "이민정",
    de: "소아청소년과",
    s: ["소아 호흡기", "알레르기 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002573",
    hid: "cmcseoul",
    n: "조윤경",
    de: "소아청소년과",
    s: ["발열", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003110",
    hid: "cmcseoul",
    n: "송승하",
    de: "소아청소년과",
    s: ["발열", "불명열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002788",
    hid: "cmcseoul",
    n: "문수영",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002712",
    hid: "cmcseoul",
    n: "정가은",
    de: "소아청소년과",
    s: ["성장장애 및 성조숙증", "성선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002902",
    hid: "cmcseoul",
    n: "박유경",
    de: "소아청소년과",
    s: ["성장장애 및 성조숙증", "성선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002381",
    hid: "cmcseoul",
    n: "김솔",
    de: "소아청소년과",
    s: ["신생아질환", "미숙아질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002774",
    hid: "cmcseoul",
    n: "신은정",
    de: "소아청소년과",
    s: ["소아중환자", "소아심장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002775",
    hid: "cmcseoul",
    n: "고지원",
    de: "소아청소년과",
    s: ["신생아중환자"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002210",
    hid: "cmcseoul",
    n: "김지혜",
    de: "소아청소년과",
    s: ["급만성복통", "구토"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002773",
    hid: "cmcseoul",
    n: "이경훈",
    de: "소아청소년과",
    s: ["소아 호흡기", "알레르기 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002209",
    hid: "cmcseoul",
    n: "성현정",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002973",
    hid: "cmcseoul",
    n: "김한준",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002972",
    hid: "cmcseoul",
    n: "두기현",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002982",
    hid: "cmcseoul",
    n: "선우윤",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002959",
    hid: "cmcseoul",
    n: "허미연",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003054",
    hid: "cmcseoul",
    n: "이고은",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003105",
    hid: "cmcseoul",
    n: "박선우",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003107",
    hid: "cmcseoul",
    n: "정청강",
    de: "소아청소년과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000867",
    hid: "cmcseoul",
    n: "이인석",
    de: "소화기내과",
    s: ["담관질환", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000898",
    hid: "cmcseoul",
    n: "조영석",
    de: "소화기내과",
    s: ["크론병", "궤양성 대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001070",
    hid: "cmcseoul",
    n: "박재명",
    de: "소화기내과",
    s: ["소화기종양치료내시경", "위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001142",
    hid: "cmcseoul",
    n: "조유경",
    de: "소화기내과",
    s: ["치료내시경", "위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001148",
    hid: "cmcseoul",
    n: "장정원",
    de: "소화기내과",
    s: ["간염", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000297",
    hid: "cmcseoul",
    n: "성필수",
    de: "소화기내과",
    s: ["간암", "고위험지방간"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000223",
    hid: "cmcseoul",
    n: "이한희",
    de: "소화기내과",
    s: ["크론병", "궤양성 대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002941",
    hid: "cmcseoul",
    n: "백규현",
    de: "소화기내과",
    s: ["췌장질환(췌장암", "췌장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001992",
    hid: "cmcseoul",
    n: "강동훈",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001913",
    hid: "cmcseoul",
    n: "한지원",
    de: "소화기내과",
    s: ["간암", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001788",
    hid: "cmcseoul",
    n: "김일수",
    de: "소화기내과",
    s: ["치료내시경", "용종절제술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001911",
    hid: "cmcseoul",
    n: "최인형",
    de: "소화기내과",
    s: ["대장암용종", "유암종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003072",
    hid: "cmcseoul",
    n: "김상현",
    de: "소화기내과",
    s: ["대장암용종", "유암종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002542",
    hid: "cmcseoul",
    n: "조희선",
    de: "소화기내과",
    s: ["간암", "간이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002956",
    hid: "cmcseoul",
    n: "탁권용",
    de: "소화기내과",
    s: ["간암", "간경변"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003133",
    hid: "cmcseoul",
    n: "정승현",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002344",
    hid: "cmcseoul",
    n: "김서린",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002347",
    hid: "cmcseoul",
    n: "조문영",
    de: "소화기내과",
    s: ["내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002119",
    hid: "cmcseoul",
    n: "홍민형",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001054",
    hid: "cmcseoul",
    n: "오용석",
    de: "순환기내과",
    s: ["부정맥", "심방세동"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000956",
    hid: "cmcseoul",
    n: "장기육",
    de: "순환기내과",
    s: ["협심증", "심근경색"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000801",
    hid: "cmcseoul",
    n: "정해억",
    de: "순환기내과",
    s: ["심장초음파 및 심장영상 진단", "판막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001137",
    hid: "cmcseoul",
    n: "최윤석",
    de: "순환기내과",
    s: ["협심증", "관상동맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000011",
    hid: "cmcseoul",
    n: "정우백",
    de: "순환기내과",
    s: [
      "중재심초음파(판막질환 및 구조적 심질환)",
      "심장-종양학(암환자의 심장기능 평가 및 치료)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001748",
    hid: "cmcseoul",
    n: "윤종찬",
    de: "순환기내과",
    s: ["심부전", "심장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000211",
    hid: "cmcseoul",
    n: "황병희",
    de: "순환기내과",
    s: ["협심증", "심근경색"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002309",
    hid: "cmcseoul",
    n: "정미향",
    de: "순환기내과",
    s: ["비후성 심근증", "심부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000193",
    hid: "cmcseoul",
    n: "추은호",
    de: "순환기내과",
    s: ["관상동맥질환", "고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000477",
    hid: "cmcseoul",
    n: "최영",
    de: "순환기내과",
    s: ["심방세동", "심장재동기화치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002052",
    hid: "cmcseoul",
    n: "이관용",
    de: "순환기내과",
    s: ["흉통", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000310",
    hid: "cmcseoul",
    n: "김진진",
    de: "순환기내과",
    s: ["심인성쇼크", "중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001881",
    hid: "cmcseoul",
    n: "오규철",
    de: "순환기내과",
    s: ["관상동맥질환", "심부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002123",
    hid: "cmcseoul",
    n: "박소윤",
    de: "순환기내과",
    s: ["부정맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002124",
    hid: "cmcseoul",
    n: "이소영",
    de: "순환기내과",
    s: ["심장초음파", "심근증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002450",
    hid: "cmcseoul",
    n: "승재호",
    de: "순환기내과",
    s: ["흉통", "협심증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003117",
    hid: "cmcseoul",
    n: "전기나",
    de: "순환기내과",
    s: ["중환자의학", "심부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003109",
    hid: "cmcseoul",
    n: "김명중",
    de: "순환기내과",
    s: ["부정맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002855",
    hid: "cmcseoul",
    n: "김의순",
    de: "순환기내과",
    s: ["심부전", "고혈압"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002854",
    hid: "cmcseoul",
    n: "김도영",
    de: "순환기내과",
    s: ["부정맥"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003053",
    hid: "cmcseoul",
    n: "오민숙",
    de: "순환기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001215",
    hid: "cmcseoul",
    n: "양동원",
    de: "신경과",
    s: ["치매", "어지럼증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000480",
    hid: "cmcseoul",
    n: "구자성",
    de: "신경과",
    s: ["[뇌졸중]", "두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001080",
    hid: "cmcseoul",
    n: "김중석",
    de: "신경과",
    s: ["파킨슨병", "이상운동질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000085",
    hid: "cmcseoul",
    n: "김우준",
    de: "신경과",
    s: ["뇌전증", "실신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002778",
    hid: "cmcseoul",
    n: "윤보라",
    de: "신경과",
    s: ["기억장애 및 치매", "경도인지장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001483",
    hid: "cmcseoul",
    n: "유상원",
    de: "신경과",
    s: ["퇴행성신경질환(치매", "이상운동질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001875",
    hid: "cmcseoul",
    n: "이정환",
    de: "신경과",
    s: ["손발 저림", "말초신경질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002048",
    hid: "cmcseoul",
    n: "이민환",
    de: "신경과",
    s: ["뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001877",
    hid: "cmcseoul",
    n: "이한빈",
    de: "신경과",
    s: ["뇌졸중", "두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002795",
    hid: "cmcseoul",
    n: "윤미연",
    de: "신경과",
    s: ["뇌전증", "수면질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002796",
    hid: "cmcseoul",
    n: "이혁제",
    de: "신경과",
    s: ["기억장애 및 치매"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002797",
    hid: "cmcseoul",
    n: "임한솔",
    de: "신경과",
    s: ["손발저림", "말초신경질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000382",
    hid: "cmcseoul",
    n: "신용삼",
    de: "신경외과",
    s: ["뇌혈관질환(뇌동맥류", "뇌출혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001123",
    hid: "cmcseoul",
    n: "손병철",
    de: "신경외과",
    s: ["얼굴손떨림", "사경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001167",
    hid: "cmcseoul",
    n: "이관성",
    de: "신경외과",
    s: ["모야모야병", "뇌동맥류"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001091",
    hid: "cmcseoul",
    n: "류경식",
    de: "신경외과",
    s: ["척추 및 척수종양", "퇴행성 척추질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000028",
    hid: "cmcseoul",
    n: "김진성",
    de: "신경외과",
    s: ["최소침습 척추수술", "요추"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001147",
    hid: "cmcseoul",
    n: "양승호",
    de: "신경외과",
    s: ["뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000164",
    hid: "cmcseoul",
    n: "최재호",
    de: "신경외과",
    s: ["뇌동맥류", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000313",
    hid: "cmcseoul",
    n: "박재성",
    de: "신경외과",
    s: ["뇌종양 수술(두개저 접근 및 내시경수술)", "항암치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002126",
    hid: "cmcseoul",
    n: "김정훈",
    de: "신경외과",
    s: ["척추외과(디스크", "골절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002310",
    hid: "cmcseoul",
    n: "추윤희",
    de: "신경외과",
    s: ["중환자실"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002129",
    hid: "cmcseoul",
    n: "조우철",
    de: "신경외과",
    s: ["뇌동맥류", "뇌혈관기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002671",
    hid: "cmcseoul",
    n: "김재연",
    de: "신경외과",
    s: ["뇌동맥류", "뇌혈관기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002672",
    hid: "cmcseoul",
    n: "이승윤",
    de: "신경외과",
    s: ["뇌동맥류", "뇌혈관기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003131",
    hid: "cmcseoul",
    n: "정해윤",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003132",
    hid: "cmcseoul",
    n: "최제민",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001046",
    hid: "cmcseoul",
    n: "박철휘",
    de: "신장내과",
    s: ["당뇨병 신장병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000057",
    hid: "cmcseoul",
    n: "정병하",
    de: "신장내과",
    s: ["신장이식", "사구체신염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002952",
    hid: "cmcseoul",
    n: "윤혜은",
    de: "신장내과",
    s: ["신장이식", "만성콩팥병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000079",
    hid: "cmcseoul",
    n: "박훈석",
    de: "신장내과",
    s: ["혈뇨", "단백뇨"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001569",
    hid: "cmcseoul",
    n: "김예니",
    de: "신장내과",
    s: ["만성신부전", "혈액투석"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001921",
    hid: "cmcseoul",
    n: "이한비",
    de: "신장내과",
    s: ["신장이식", "사구체신염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002960",
    hid: "cmcseoul",
    n: "김비오",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002961",
    hid: "cmcseoul",
    n: "엄예나",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002962",
    hid: "cmcseoul",
    n: "윤지영",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003029",
    hid: "cmcseoul",
    n: "김지성",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003137",
    hid: "cmcseoul",
    n: "신경원",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003130",
    hid: "cmcseoul",
    n: "홍지연",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000997",
    hid: "cmcseoul",
    n: "문석환",
    de: "심장혈관흉부외과",
    s: ["폐결절", "흉강경폐암및식도암수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001153",
    hid: "cmcseoul",
    n: "김영두",
    de: "심장혈관흉부외과",
    s: ["폐암", "전이성 폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000642",
    hid: "cmcseoul",
    n: "이철",
    de: "심장혈관흉부외과",
    s: ["소아 심장외과", "소아 선천성심장병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000023",
    hid: "cmcseoul",
    n: "김환욱",
    de: "심장혈관흉부외과",
    s: ["성인판막질환", "대동맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000207",
    hid: "cmcseoul",
    n: "김용한",
    de: "심장혈관흉부외과",
    s: ["관상동맥우회술", "성인판막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000159",
    hid: "cmcseoul",
    n: "김경수",
    de: "심장혈관흉부외과",
    s: ["폐암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000173",
    hid: "cmcseoul",
    n: "문미형",
    de: "심장혈관흉부외과",
    s: ["종격동 종양", "흉선종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001872",
    hid: "cmcseoul",
    n: "이원영",
    de: "심장혈관흉부외과",
    s: ["소아 선천성 심질환 성인 선천성 심질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002367",
    hid: "cmcseoul",
    n: "윤승근",
    de: "심장혈관흉부외과",
    s: ["폐종양", "종격동종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002579",
    hid: "cmcseoul",
    n: "임현아",
    de: "심장혈관흉부외과",
    s: ["성인심장혈관질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000979",
    hid: "cmcseoul",
    n: "박찬기",
    de: "안과",
    s: ["녹내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001160",
    hid: "cmcseoul",
    n: "양석우",
    de: "안과",
    s: ["성형안과", "눈꺼풀종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001116",
    hid: "cmcseoul",
    n: "김현승",
    de: "안과",
    s: ["백내장", "각막이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001081",
    hid: "cmcseoul",
    n: "박영훈",
    de: "안과",
    s: ["황반변성", "망막박리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000328",
    hid: "cmcseoul",
    n: "신선영",
    de: "안과",
    s: ["고도근시", "근시치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000377",
    hid: "cmcseoul",
    n: "정소향",
    de: "안과",
    s: ["백내장", "각막이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000067",
    hid: "cmcseoul",
    n: "박신혜",
    de: "안과",
    s: ["소아안과", "사시"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000209",
    hid: "cmcseoul",
    n: "박혜영",
    de: "안과",
    s: ["녹내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000186",
    hid: "cmcseoul",
    n: "변용수",
    de: "안과",
    s: ["각막이식", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000257",
    hid: "cmcseoul",
    n: "박영근",
    de: "안과",
    s: ["망막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000255",
    hid: "cmcseoul",
    n: "정경인",
    de: "안과",
    s: ["녹내장", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000553",
    hid: "cmcseoul",
    n: "김미리내",
    de: "안과",
    s: ["망막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002071",
    hid: "cmcseoul",
    n: "황보인",
    de: "안과",
    s: ["망막진료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002779",
    hid: "cmcseoul",
    n: "박정열",
    de: "안과",
    s: ["성형안과", "안검하수"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001379",
    hid: "cmcseoul",
    n: "김래영",
    de: "안과",
    s: ["망막 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002444",
    hid: "cmcseoul",
    n: "신희종",
    de: "안과",
    s: ["녹내장", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001923",
    hid: "cmcseoul",
    n: "김주영",
    de: "안과",
    s: ["망막질환", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002385",
    hid: "cmcseoul",
    n: "김기현",
    de: "안과",
    s: ["망막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002387",
    hid: "cmcseoul",
    n: "홍서연",
    de: "안과",
    s: ["망막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002574",
    hid: "cmcseoul",
    n: "이지혜",
    de: "안과",
    s: ["망막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002891",
    hid: "cmcseoul",
    n: "서현",
    de: "안과",
    s: ["망막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002888",
    hid: "cmcseoul",
    n: "송지윤",
    de: "안과",
    s: ["각막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002978",
    hid: "cmcseoul",
    n: "박주예",
    de: "안과",
    s: ["각막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002889",
    hid: "cmcseoul",
    n: "유경민",
    de: "안과",
    s: ["망막", "백내장"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000977",
    hid: "cmcseoul",
    n: "이숙영",
    de: "알레르기내과",
    s: ["천식", "만성기침"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000364",
    hid: "cmcseoul",
    n: "이화영",
    de: "알레르기내과",
    s: ["만성기침", "천식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000996",
    hid: "cmcseoul",
    n: "김범수",
    de: "영상의학과",
    s: ["신경두경부영상의학", "신경중재치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001124",
    hid: "cmcseoul",
    n: "안국진",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001169",
    hid: "cmcseoul",
    n: "최병길",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001162",
    hid: "cmcseoul",
    n: "정소령",
    de: "영상의학과",
    s: ["신경두경부영상의학", "갑상선영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000860",
    hid: "cmcseoul",
    n: "정정임",
    de: "영상의학과",
    s: ["심장영상의학", "흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000896",
    hid: "cmcseoul",
    n: "나성은",
    de: "영상의학과",
    s: ["복부영상의학", "비뇨생식기영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000906",
    hid: "cmcseoul",
    n: "천호종",
    de: "영상의학과",
    s: ["혈관 및 인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000430",
    hid: "cmcseoul",
    n: "한대희",
    de: "영상의학과",
    s: ["흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001009",
    hid: "cmcseoul",
    n: "임수아",
    de: "영상의학과",
    s: ["소아영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001062",
    hid: "cmcseoul",
    n: "김성헌",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000486",
    hid: "cmcseoul",
    n: "최준일",
    de: "영상의학과",
    s: ["복부영상의학", "비뇨생식기영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001140",
    hid: "cmcseoul",
    n: "오순남",
    de: "영상의학과",
    s: ["복부영상의학", "비뇨생식기영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001187",
    hid: "cmcseoul",
    n: "강봉주",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000075",
    hid: "cmcseoul",
    n: "정준용",
    de: "영상의학과",
    s: ["근골격 영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001754",
    hid: "cmcseoul",
    n: "이소연",
    de: "영상의학과",
    s: ["근골격 영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001554",
    hid: "cmcseoul",
    n: "신유리",
    de: "영상의학과",
    s: ["복부영상의학", "비뇨생식기영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000232",
    hid: "cmcseoul",
    n: "장진희",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000120",
    hid: "cmcseoul",
    n: "오정석",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001888",
    hid: "cmcseoul",
    n: "김보현",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002782",
    hid: "cmcseoul",
    n: "문한송",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002311",
    hid: "cmcseoul",
    n: "이지영",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001502",
    hid: "cmcseoul",
    n: "장수연",
    de: "영상의학과",
    s: ["흉부영상의학", "심장영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000456",
    hid: "cmcseoul",
    n: "백경민",
    de: "영상의학과",
    s: ["흉부영상의학", "심장영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000444",
    hid: "cmcseoul",
    n: "김수호",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001453",
    hid: "cmcseoul",
    n: "박가은",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001639",
    hid: "cmcseoul",
    n: "이승은",
    de: "영상의학과",
    s: ["근골격 영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002620",
    hid: "cmcseoul",
    n: "신일아",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001928",
    hid: "cmcseoul",
    n: "김호군",
    de: "영상의학과",
    s: ["복부영상의학", "비뇨생식기영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002458",
    hid: "cmcseoul",
    n: "이승원",
    de: "영상의학과",
    s: ["근골격 영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001637",
    hid: "cmcseoul",
    n: "윤서연",
    de: "영상의학과",
    s: ["복부 및 비뇨 영상의학", "경피적 조직검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002783",
    hid: "cmcseoul",
    n: "박혜민",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002981",
    hid: "cmcseoul",
    n: "전병욱",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002531",
    hid: "cmcseoul",
    n: "김형진",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002653",
    hid: "cmcseoul",
    n: "이문옥",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001276",
    hid: "cmcseoul",
    n: "이주현",
    de: "영상의학과",
    s: ["신경두경부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002217",
    hid: "cmcseoul",
    n: "조예슬",
    de: "영상의학과",
    s: ["흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001449",
    hid: "cmcseoul",
    n: "하승미",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002218",
    hid: "cmcseoul",
    n: "임주희",
    de: "영상의학과",
    s: ["유방영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002446",
    hid: "cmcseoul",
    n: "김동균",
    de: "영상의학과",
    s: ["근골격 영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002182",
    hid: "cmcseoul",
    n: "황선영",
    de: "영상의학과",
    s: ["근골격영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002661",
    hid: "cmcseoul",
    n: "이은지",
    de: "영상의학과",
    s: ["흉부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002189",
    hid: "cmcseoul",
    n: "조소영",
    de: "영상의학과",
    s: ["복부영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002858",
    hid: "cmcseoul",
    n: "김용상",
    de: "영상의학과",
    s: ["인터벤션영상의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002407",
    hid: "cmcseoul",
    n: "고세영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002971",
    hid: "cmcseoul",
    n: "심은정",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002970",
    hid: "cmcseoul",
    n: "이다인",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002332",
    hid: "cmcseoul",
    n: "이상영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002392",
    hid: "cmcseoul",
    n: "이희린",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002904",
    hid: "cmcseoul",
    n: "허수진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002998",
    hid: "cmcseoul",
    n: "박진은",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001515",
    hid: "cmcseoul",
    n: "김혜원",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002312",
    hid: "cmcseoul",
    n: "노승연",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002313",
    hid: "cmcseoul",
    n: "안창호",
    de: "완화의학과",
    s: ["호스피스 완화의학", "암성통증관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001462",
    hid: "cmcseoul",
    n: "김기철",
    de: "완화의학과",
    s: ["호스피스 완화의학", "암성통증관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002401",
    hid: "cmcseoul",
    n: "박재영",
    de: "완화의학과",
    s: ["호스피스 완화의학", "암성통증관리"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003123",
    hid: "cmcseoul",
    n: "신은경",
    de: "완화의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001016",
    hid: "cmcseoul",
    n: "송교영",
    de: "위장관외과",
    s: ["[위암]", "로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000051",
    hid: "cmcseoul",
    n: "이한홍",
    de: "위장관외과",
    s: ["위암", "상부소화기질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000349",
    hid: "cmcseoul",
    n: "서호석",
    de: "위장관외과",
    s: ["위암", "항역류수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001930",
    hid: "cmcseoul",
    n: "김소정",
    de: "위장관외과",
    s: ["위암", "위종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003032",
    hid: "cmcseoul",
    n: "박지현",
    de: "위장관외과",
    s: ["위암", "위기질성종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002221",
    hid: "cmcseoul",
    n: "송무형",
    de: "위장관외과",
    s: ["입원전문의"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001059",
    hid: "cmcseoul",
    n: "박우찬",
    de: "유방외과",
    s: ["[유방암]"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002049",
    hid: "cmcseoul",
    n: "배수연",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001508",
    hid: "cmcseoul",
    n: "윤창익",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002051",
    hid: "cmcseoul",
    n: "이영주",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002050",
    hid: "cmcseoul",
    n: "김두레",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002625",
    hid: "cmcseoul",
    n: "이진아",
    de: "유방외과",
    s: ["유방암", "소엽암(침윤성/비침윤성) 파제트병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002880",
    hid: "cmcseoul",
    n: "진제현",
    de: "유방외과",
    s: ["유방암", "소엽암(침윤성/비침윤성)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003139",
    hid: "cmcseoul",
    n: "최재원",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003082",
    hid: "cmcseoul",
    n: "지현아",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003083",
    hid: "cmcseoul",
    n: "장유경",
    de: "유방외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001031",
    hid: "cmcseoul",
    n: "박규남",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000950",
    hid: "cmcseoul",
    n: "김영민",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000032",
    hid: "cmcseoul",
    n: "김한준",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000044",
    hid: "cmcseoul",
    n: "윤준성",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000202",
    hid: "cmcseoul",
    n: "오상훈",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000440",
    hid: "cmcseoul",
    n: "임지용",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001258",
    hid: "cmcseoul",
    n: "김효준",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001841",
    hid: "cmcseoul",
    n: "배우리",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002013",
    hid: "cmcseoul",
    n: "김지수",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001565",
    hid: "cmcseoul",
    n: "박성진",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002457",
    hid: "cmcseoul",
    n: "김지영",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002140",
    hid: "cmcseoul",
    n: "방효진",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002403",
    hid: "cmcseoul",
    n: "김근호",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002405",
    hid: "cmcseoul",
    n: "유지수",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002404",
    hid: "cmcseoul",
    n: "지윤경",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002585",
    hid: "cmcseoul",
    n: "공애경",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002879",
    hid: "cmcseoul",
    n: "이지숙",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003022",
    hid: "cmcseoul",
    n: "김서연",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003106",
    hid: "cmcseoul",
    n: "배주연",
    de: "응급의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000983",
    hid: "cmcseoul",
    n: "선동일",
    de: "이비인후과",
    s: ["두경부종양", "음성장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000905",
    hid: "cmcseoul",
    n: "김수환",
    de: "이비인후과",
    s: ["코중격만곡증 및 외비변형", "알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000894",
    hid: "cmcseoul",
    n: "박경호",
    de: "이비인후과",
    s: ["난청", "이명"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000970",
    hid: "cmcseoul",
    n: "박시내",
    de: "이비인후과",
    s: ["난청", "이명"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001015",
    hid: "cmcseoul",
    n: "김성원",
    de: "이비인후과",
    s: ["축농증", "코종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001235",
    hid: "cmcseoul",
    n: "서재현",
    de: "이비인후과",
    s: ["어지럼증", "중이염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001688",
    hid: "cmcseoul",
    n: "박준욱",
    de: "이비인후과",
    s: ["두경부암(구강암", "인후두암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000315",
    hid: "cmcseoul",
    n: "김도현",
    de: "이비인후과",
    s: ["악성 및 양성 비강 종양 (코 종양)", "만성 부비동염 (축농증)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000225",
    hid: "cmcseoul",
    n: "김상연",
    de: "이비인후과",
    s: ["두경부종양", "갑상선종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002445",
    hid: "cmcseoul",
    n: "임지형",
    de: "이비인후과",
    s: ["어지럼증", "중이염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002578",
    hid: "cmcseoul",
    n: "이재윤",
    de: "이비인후과",
    s: ["축농증", "코중격만곡증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003111",
    hid: "cmcseoul",
    n: "강승헌",
    de: "이비인후과",
    s: ["후두음성질환", "기도질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002802",
    hid: "cmcseoul",
    n: "전민채",
    de: "이비인후과",
    s: ["난청", "이명"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002801",
    hid: "cmcseoul",
    n: "이찬미",
    de: "이비인후과",
    s: ["난청", "이명"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003112",
    hid: "cmcseoul",
    n: "최수인",
    de: "임상약리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001951",
    hid: "cmcseoul",
    n: "남이슬",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001651",
    hid: "cmcseoul",
    n: "이승환",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002184",
    hid: "cmcseoul",
    n: "박홍민",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002316",
    hid: "cmcseoul",
    n: "조재호",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002781",
    hid: "cmcseoul",
    n: "송여진",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002820",
    hid: "cmcseoul",
    n: "박근영",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001650",
    hid: "cmcseoul",
    n: "김주리",
    de: "입원의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001008",
    hid: "cmcseoul",
    n: "이종인",
    de: "재활의학과",
    s: ["근골격계재활", "림프부종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001459",
    hid: "cmcseoul",
    n: "남경은",
    de: "재활의학과",
    s: ["근골격계 통증", "심장 및 호흡(폐)재활"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000295",
    hid: "cmcseoul",
    n: "박혜정",
    de: "재활의학과",
    s: ["소아재활", "족부통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003156",
    hid: "cmcseoul",
    n: "허양록",
    de: "재활의학과",
    s: ["근골격계재활", "스포츠재활"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000934",
    hid: "cmcseoul",
    n: "이창욱",
    de: "정신건강의학과",
    s: ["기억력장애 및 치매", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001039",
    hid: "cmcseoul",
    n: "채정호",
    de: "정신건강의학과",
    s: ["불안장애", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001175",
    hid: "cmcseoul",
    n: "김대진",
    de: "정신건강의학과",
    s: ["알코올", "니코틴 및 약물/행위 중독"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001063",
    hid: "cmcseoul",
    n: "김태석",
    de: "정신건강의학과",
    s: ["정신신체의학", "정신종양학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000331",
    hid: "cmcseoul",
    n: "강동우",
    de: "정신건강의학과",
    s: ["기억력 장애 및 인지저하", "경도인지장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001562",
    hid: "cmcseoul",
    n: "유재현",
    de: "정신건강의학과",
    s: ["ADHD", "발달장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002862",
    hid: "cmcseoul",
    n: "이준희",
    de: "정신건강의학과",
    s: ["조현병", "기분장애(조울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002903",
    hid: "cmcseoul",
    n: "변기환",
    de: "정신건강의학과",
    s: ["노인", "중독"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002317",
    hid: "cmcseoul",
    n: "박미진",
    de: "정신건강의학과",
    s: ["우울증", "불안장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003024",
    hid: "cmcseoul",
    n: "김지원",
    de: "정신건강의학과",
    s: ["불안장애", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001181",
    hid: "cmcseoul",
    n: "정양국",
    de: "정형외과",
    s: ["수부상지 질환 및 말초신경질환 질환", "골연부조직 종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000538",
    hid: "cmcseoul",
    n: "안재훈",
    de: "정형외과",
    s: ["족부외과", "관절내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000857",
    hid: "cmcseoul",
    n: "인용",
    de: "정형외과",
    s: ["무릎관절질환", "인공관절클리닉"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000893",
    hid: "cmcseoul",
    n: "김양수",
    de: "정형외과",
    s: ["오십견", "어깨관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000987",
    hid: "cmcseoul",
    n: "김기원",
    de: "정형외과",
    s: ["고령환자 척추질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000280",
    hid: "cmcseoul",
    n: "김영훈",
    de: "정형외과",
    s: ["척추변형", "척추종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000010",
    hid: "cmcseoul",
    n: "임영욱",
    de: "정형외과",
    s: ["인공고관절치환술", "고관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001367",
    hid: "cmcseoul",
    n: "김만수",
    de: "정형외과",
    s: ["무릎관절 질환 및 손상", "무릎 퇴행성 관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000185",
    hid: "cmcseoul",
    n: "이효진",
    de: "정형외과",
    s: ["오십견", "어깨관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000235",
    hid: "cmcseoul",
    n: "조우람",
    de: "정형외과",
    s: ["고관절 질환", "인공고관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000293",
    hid: "cmcseoul",
    n: "김상일",
    de: "정형외과",
    s: ["척추변형", "경추질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003114",
    hid: "cmcseoul",
    n: "노연태",
    de: "정형외과",
    s: ["수부 및 수근관절", "주관절(팔꿈치)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001649",
    hid: "cmcseoul",
    n: "최근영",
    de: "정형외과",
    s: ["무릎 관절질환 및 외상", "퇴행성 관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002365",
    hid: "cmcseoul",
    n: "조성현",
    de: "정형외과",
    s: ["주관절 및 견관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002860",
    hid: "cmcseoul",
    n: "권기현",
    de: "정형외과",
    s: ["경추", "흉추"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003025",
    hid: "cmcseoul",
    n: "이지원",
    de: "정형외과",
    s: ["족부"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003127",
    hid: "cmcseoul",
    n: "서정용",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003128",
    hid: "cmcseoul",
    n: "이효진",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000962",
    hid: "cmcseoul",
    n: "이명아",
    de: "종양내과",
    s: ["[대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000018",
    hid: "cmcseoul",
    n: "홍숙희",
    de: "종양내과",
    s: ["[폐암", "부인암]"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003151",
    hid: "cmcseoul",
    n: "백지연",
    de: "종양내과",
    s: ["대장암", "소장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000262",
    hid: "cmcseoul",
    n: "김인호",
    de: "종양내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000304",
    hid: "cmcseoul",
    n: "이지은",
    de: "종양내과",
    s: ["유방암", "육종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001413",
    hid: "cmcseoul",
    n: "박세준",
    de: "종양내과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001411",
    hid: "cmcseoul",
    n: "신갑수",
    de: "종양내과",
    s: ["유방암", "위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003018",
    hid: "cmcseoul",
    n: "박송이",
    de: "종양내과",
    s: ["두경부암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002351",
    hid: "cmcseoul",
    n: "박혜원",
    de: "종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000339",
    hid: "cmcseoul",
    n: "김은영",
    de: "중환자외상외과",
    s: ["중환자의학", "외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002147",
    hid: "cmcseoul",
    n: "이겨라",
    de: "중환자외상외과",
    s: ["중환자의학", "외상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003028",
    hid: "cmcseoul",
    n: "임경무",
    de: "중환자외상외과",
    s: ["입원전문의"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000781",
    hid: "cmcseoul",
    n: "구정완",
    de: "직업환경의학과",
    s: ["진폐증", "직업성 및 환경성 호흡기 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000238",
    hid: "cmcseoul",
    n: "김형렬",
    de: "직업환경의학과",
    s: ["직업병 일반", "근골격계질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000208",
    hid: "cmcseoul",
    n: "명준표",
    de: "직업환경의학과",
    s: ["진폐증", "직업성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000694",
    hid: "cmcseoul",
    n: "강모열",
    de: "직업환경의학과",
    s: ["직업병 일반", "근골격계질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001743",
    hid: "cmcseoul",
    n: "이종인",
    de: "직업환경의학과",
    s: ["진폐증 및 환경성/직업성 호흡기질환", "가습기살균제 보건센터"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002582",
    hid: "cmcseoul",
    n: "박민영",
    de: "직업환경의학과",
    s: ["가습기살균제 보건센터", "근골격계질환 특별진찰"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003120",
    hid: "cmcseoul",
    n: "김서영",
    de: "직업환경의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000815",
    hid: "cmcseoul",
    n: "박연준",
    de: "진단검사의학과",
    s: ["임상미생물"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000938",
    hid: "cmcseoul",
    n: "김용구",
    de: "진단검사의학과",
    s: ["진단 혈액", "세포 치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000914",
    hid: "cmcseoul",
    n: "오은지",
    de: "진단검사의학과",
    s: ["진단면역"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000999",
    hid: "cmcseoul",
    n: "김명신",
    de: "진단검사의학과",
    s: ["유전 진단", "진단 혈액"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000167",
    hid: "cmcseoul",
    n: "채효진",
    de: "진단검사의학과",
    s: ["임상 화학", "유전 진단"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001555",
    hid: "cmcseoul",
    n: "제갈동욱",
    de: "진단검사의학과",
    s: ["수혈의학 세포치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001874",
    hid: "cmcseoul",
    n: "유인영",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001939",
    hid: "cmcseoul",
    n: "이종미",
    de: "진단검사의학과",
    s: ["진단혈액", "유전상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002148",
    hid: "cmcseoul",
    n: "김훈석",
    de: "진단검사의학과",
    s: ["유전진단", "유전상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002149",
    hid: "cmcseoul",
    n: "정진",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003118",
    hid: "cmcseoul",
    n: "홍윤지",
    de: "진단검사의학과",
    s: ["유전 진단", "유전 상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003134",
    hid: "cmcseoul",
    n: "강탁호",
    de: "진단검사의학과",
    s: ["진단혈액"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001120",
    hid: "cmcseoul",
    n: "김창현",
    de: "치과병원",
    s: ["악안면골절", "종양 및 재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000145",
    hid: "cmcseoul",
    n: "모성서",
    de: "치과병원",
    s: ["성장기 치열교정 및 턱교정", "매복치 및 치아위치이상의 교정치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000149",
    hid: "cmcseoul",
    n: "양성은",
    de: "치과병원",
    s: ["근관치료", "현미경 치근단수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000279",
    hid: "cmcseoul",
    n: "고영경",
    de: "치과병원",
    s: ["잇몸질환", "잇몸성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000429",
    hid: "cmcseoul",
    n: "김신영",
    de: "치과병원",
    s: ["근관치료", "현미경 치근단수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000541",
    hid: "cmcseoul",
    n: "박준범",
    de: "치과병원",
    s: ["잇몸질환", "잇몸성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000378",
    hid: "cmcseoul",
    n: "김윤지",
    de: "치과병원",
    s: ["성장기치열교정및턱교정", "매복치및치아이상의교정치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000544",
    hid: "cmcseoul",
    n: "이수영",
    de: "치과병원",
    s: ["임플란트", "심미보철"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000545",
    hid: "cmcseoul",
    n: "이원섭",
    de: "치과병원",
    s: ["임플란트", "심미보철"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002621",
    hid: "cmcseoul",
    n: "한성훈",
    de: "치과병원",
    s: ["성장기 치열교정 및 턱교정", "매복치 및 치아이상의 교정치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002615",
    hid: "cmcseoul",
    n: "박원종",
    de: "치과병원",
    s: ["구강암 및 악안면 종양", "악교정수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002977",
    hid: "cmcseoul",
    n: "남시은",
    de: "치과병원",
    s: ["근관치료", "현미경 치근단수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003124",
    hid: "cmcseoul",
    n: "탁승홍",
    de: "치과병원",
    s: ["악안면골절", "임플란트"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001035",
    hid: "cmcseoul",
    n: "박영민",
    de: "피부과",
    s: ["소아알레르기피부질환(아토피피부염)", "두드러기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000214",
    hid: "cmcseoul",
    n: "이지현",
    de: "피부과",
    s: ["[소아", "성인아토피피부염]"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000347",
    hid: "cmcseoul",
    n: "방철환",
    de: "피부과",
    s: ["건선", "접촉피부염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001448",
    hid: "cmcseoul",
    n: "한주희",
    de: "피부과",
    s: ["백반증", "건선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002588",
    hid: "cmcseoul",
    n: "육화정",
    de: "피부과",
    s: ["아토피피부염", "모발"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002953",
    hid: "cmcseoul",
    n: "송유미",
    de: "피부과",
    s: ["보톡스", "피부미용"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000776",
    hid: "cmcseoul",
    n: "김성훈",
    de: "핵의학과",
    s: ["종양 핵의학", "갑상선암 동위원소 치료 및 신장 핵의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001018",
    hid: "cmcseoul",
    n: "유이령",
    de: "핵의학과",
    s: ["종양", "뇌신경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000160",
    hid: "cmcseoul",
    n: "오주현",
    de: "핵의학과",
    s: ["종양 핵의학 (혈액암", "전립선암)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001758",
    hid: "cmcseoul",
    n: "하승균",
    de: "핵의학과",
    s: ["동위원소 치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002966",
    hid: "cmcseoul",
    n: "강연구",
    de: "핵의학과",
    s: ["동위원소 치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002150",
    hid: "cmcseoul",
    n: "이영주",
    de: "핵의학과",
    s: ["동위원소 치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001051",
    hid: "cmcseoul",
    n: "윤상섭",
    de: "혈관ㆍ이식외과",
    s: ["이식(신장", "췌장)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000601",
    hid: "cmcseoul",
    n: "김장용",
    de: "혈관ㆍ이식외과",
    s: ["대동맥류", "정맥류"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001145",
    hid: "cmcseoul",
    n: "박순철",
    de: "혈관ㆍ이식외과",
    s: ["이식(신장", "췌장)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002955",
    hid: "cmcseoul",
    n: "오행진",
    de: "혈관ㆍ이식외과",
    s: ["투석접근로", "하지혈관질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002208",
    hid: "cmcseoul",
    n: "문기윤",
    de: "혈관ㆍ이식외과",
    s: ["신장이식", "동맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002358",
    hid: "cmcseoul",
    n: "장은주",
    de: "혈관ㆍ이식외과",
    s: ["신장이식", "동맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003140",
    hid: "cmcseoul",
    n: "변원재",
    de: "혈관ㆍ이식외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003141",
    hid: "cmcseoul",
    n: "윤영하",
    de: "혈관ㆍ이식외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001028",
    hid: "cmcseoul",
    n: "조석구",
    de: "혈액내과",
    s: ["림프종", "면역세포치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001178",
    hid: "cmcseoul",
    n: "김희제",
    de: "혈액내과",
    s: ["급성골수성백혈병", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001185",
    hid: "cmcseoul",
    n: "민창기",
    de: "혈액내과",
    s: ["다발골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001012",
    hid: "cmcseoul",
    n: "엄기성",
    de: "혈액내과",
    s: ["림프종", "만성림프구백혈병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000854",
    hid: "cmcseoul",
    n: "김유진",
    de: "혈액내과",
    s: ["골수형성이상종양", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001202",
    hid: "cmcseoul",
    n: "조병식",
    de: "혈액내과",
    s: ["급성골수성백혈병", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000203",
    hid: "cmcseoul",
    n: "이성은",
    de: "혈액내과",
    s: ["만성골수성백혈병", "골수증식질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003113",
    hid: "cmcseoul",
    n: "최윤석",
    de: "혈액내과",
    s: ["림프종", "만성림프구백혈병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002318",
    hid: "cmcseoul",
    n: "태현정",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000135",
    hid: "cmcseoul",
    n: "윤재호",
    de: "혈액내과",
    s: ["급성림프구성백혈", "혈구탐식성조직구증식증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001467",
    hid: "cmcseoul",
    n: "박실비아",
    de: "혈액내과",
    s: ["재생불량빈혈", "골수형성이상종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000344",
    hid: "cmcseoul",
    n: "박성수",
    de: "혈액내과",
    s: ["다발골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000561",
    hid: "cmcseoul",
    n: "민기준",
    de: "혈액내과",
    s: ["림프종", "만성림프구성백혈병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002056",
    hid: "cmcseoul",
    n: "곽대훈",
    de: "혈액내과",
    s: ["급성골수성백혈병", "조혈모세포이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002026",
    hid: "cmcseoul",
    n: "지수영",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001716",
    hid: "cmcseoul",
    n: "이정연",
    de: "혈액내과",
    s: ["다발골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002980",
    hid: "cmcseoul",
    n: "변성규",
    de: "혈액내과",
    s: ["다발골수종", "아밀로이드증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002617",
    hid: "cmcseoul",
    n: "한선영",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002228",
    hid: "cmcseoul",
    n: "민지연",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002677",
    hid: "cmcseoul",
    n: "남호형",
    de: "혈액내과",
    s: ["일반혈액질환", "골수증식종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002072",
    hid: "cmcseoul",
    n: "오미내",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001887",
    hid: "cmcseoul",
    n: "김찬영",
    de: "혈액내과",
    s: ["혈액내과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002551",
    hid: "cmcseoul",
    n: "박소연",
    de: "혈액내과",
    s: ["일반혈액질환", "골수부전(재생불량빈혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003021",
    hid: "cmcseoul",
    n: "조현이",
    de: "혈액내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001093",
    hid: "cmcseoul",
    n: "김석찬",
    de: "호흡기내과",
    s: ["중환자의학", "급성호흡부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000825",
    hid: "cmcseoul",
    n: "김승준",
    de: "호흡기내과",
    s: ["폐암", "폐결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001025",
    hid: "cmcseoul",
    n: "김진우",
    de: "호흡기내과",
    s: ["기도질환", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002321",
    hid: "cmcseoul",
    n: "민진수",
    de: "호흡기내과",
    s: ["결핵", "다제내성 결핵"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002230",
    hid: "cmcseoul",
    n: "조용숙",
    de: "호흡기내과",
    s: ["간질성 폐질환", "폐섬유증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0003043",
    hid: "cmcseoul",
    n: "장유진",
    de: "호흡기내과",
    s: ["중환자의학", "급성호흡곤란증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002003",
    hid: "cmcseoul",
    n: "조형준",
    de: "호흡기내과",
    s: ["폐암", "치료적 기관지내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002547",
    hid: "cmcseoul",
    n: "이종민",
    de: "호흡기내과",
    s: ["중환자의학", "급성호흡곤란증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0002548",
    hid: "cmcseoul",
    n: "이지원",
    de: "호흡기내과",
    s: ["폐암", "폐결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0001800",
    hid: "cmcseoul",
    n: "서완",
    de: "호흡기내과",
    s: ["기관지 내시경 검사", "수술 전 평가"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "D0000147",
    hid: "cmcseoul",
    n: "옥진주",
    de: "여행의학 클리닉",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
];
